import React from "react";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import { useSendbird } from "@/hooks/useSendbird";
import { getCustomApiHost } from "@/lib/sendbird";
import "@sendbird/uikit-react/dist/index.css";

/**
 * SendbirdRoot — global UIKit provider wrapper.
 *
 * Mounted once, high in the tree, so <GroupChannel /> and <GroupChannelList />
 * embeds anywhere in the app share a single Sendbird SDK connection.
 *
 * Behaviour:
 *   - Renders children as-is when not authenticated / session not ready. Any
 *     nested UIKit component will simply not receive a provider — they should
 *     guard on `useSendbird().ready`.
 *   - Renders <SendbirdProvider> around children once the session-token has
 *     been fetched.
 *   - Uses `theme="light"` (dark theme is Phase 8).
 */
const SendbirdRoot = ({ children }) => {
    const { session, ready } = useSendbird();

    if (!ready || !session) return <>{children}</>;

    return (
        <SendbirdProvider
            appId={session.app_id}
            userId={session.user_id}
            accessToken={session.session_token}
            nickname={session.nickname || session.user_id}
            theme="light"
            customApiHost={getCustomApiHost()}
            stringSet={{
                CHANNEL_LIST__TITLE: "Your PILLS Chats",
            }}
        >
            {children}
        </SendbirdProvider>
    );
};

export default SendbirdRoot;
